// Configuration.
import { results } from '../config';

// Utils.
import { findArrayObjByValue } from './';
import log from './log';

// Formulas.
import formulas from './formulas';

//------------------------------------------------------------------------------

const calculateResultsData = ({
  salary,
  period,
  status,
  exemptions,
  deferrals,
}) => {
  // Clone config to avoid mutations.
  const outputtedArr = [...results];

  // Assign <Results /> defaults.
  for (let i = outputtedArr.length - 1; i >= 0; i -= 1) {
    outputtedArr[i].output = 0;
  }

  // New data coming in, recalculate and reassign new values.
  if (salary && period && status && deferrals) {
    // Core calculations.
    const formulasObj = formulas(salary, period, status, exemptions, deferrals);

    // Prepare 'uids' array.
    const uidArr = outputtedArr.map(val => val.uid);

    // Reassign <Results /> values.
    uidArr.forEach(uid => {
      const uidObj = findArrayObjByValue(outputtedArr, 'uid', uid);
      if (uidObj) {
        uidObj.output = formulasObj[`${uid}Output`];
      }
    });

    // Log results only in development.
    if (process.env.NODE_ENV === 'development' && window.console.table) {
      log(salary, period, status, exemptions, deferrals, formulasObj);
    }
  }

  return outputtedArr;
};

export default calculateResultsData;



// WEBPACK FOOTER //
// ./src/utils/calculateResultsData.js